<template>
  <div class="informBox">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="head-tab">
      <el-tab-pane name="1">
        <span slot="label">{{ $t('Components.InformBox.Notification') }}<i v-if="is_new_data['1']"></i></span>
      </el-tab-pane>
      <el-tab-pane name="2">
        <span slot="label">{{ $t('Components.InformBox.Events') }}<i v-if="is_new_data['2']"></i></span>
      </el-tab-pane>
      <el-tab-pane name="3">
        <span slot="label">{{ $t('Components.InformBox.SoldOutList') }}<i v-if="is_new_data['3']" style="right:-8px"></i></span>
      </el-tab-pane>
      <el-tab-pane name="4">
        <span slot="label">{{ $t('Components.InformBox.ExportList') }}<i v-if="is_new_data['4']" style="right:-8px"></i></span>
      </el-tab-pane>
    </el-tabs>
    <div class="content">
      <template v-if="activeName == 1">
        <div v-for="item in newsList" :key="item.id" class="message-item pointer" @click="showNewFunction">
          <div class="title ellipsis">{{ item.title }}</div>
          <div class="text ellipsis">{{ item.en_date }}</div>
        </div>
      </template>
      <template v-if="activeName == 2">
        <div v-for="item in newsList" :key="item.id" class="message-item pointer" @click="showNewFunction">
          <div class="title ellipsis">{{ item.title }}</div>
          <div class="text ellipsis">{{ item.en_date }}</div>
        </div>
      </template>
      <template v-if="activeName == 3">
        <div v-for="item in productList" :key="item.id" class="product-item f-b-c pointer" @click="showNewFunction">
          <oss-img :width="40" :height="53" :src="item.imgUrl" />
          <div class="right">
            <div class="title ellipsis3">{{ item.productName }}</div>
            <div class="ellipsis">{{ item.en_date }}</div>
          </div>
        </div>
      </template>
      <template v-if="activeName == 4">
        <div v-for="item in fileTaskList" :key="item.id" class="product-item f-b-c">
          <div class="right" style="height: 60px;">
            <div class="f-b-c">
              <div class="title ellipsis3">{{ item.taskTypeName }}</div>
              <div v-if="item.fileStatusName">
                <a :style="{color: fileStatusColor(item.fileStatus)}" :href="item.fileResultPath">{{ item.fileStatusName }}</a>
              </div>
              <div v-else :style="{color: fileStatusColor(item.fileStatus)}">{{ item.fileStatusName }}</div>
            </div>
            <div class="ellipsis">{{ item.en_date }}</div>
          </div>
        </div>
      </template>
      <div class="obscuration"></div>
      <div v-if="(activeName != 3 && !newsList.length) || (activeName == 3 && !productList.length)" class="f-c-c empty">
        <img src="../assets/img/emptyCart.svg" alt="">
        <p>{{ $t('Components.InformBox.NoRecordsFound') }}</p>
      </div>
    </div>
    <div v-if="(activeName != 3 && newsList.length) || (activeName == 3 && productList.length) || (activeName == 4 && fileTaskList.length)" class="more f-c-c pointer" @click="showNewFunction">{{ $t('Components.InformBox.ViewAll') }}
      <i class="iconfont icon-Frame_2"></i>
    </div>
  </div>
</template>

<script>
import OssImg from './OssImg.vue'
import API from '@/api'
export default {
  components: { OssImg },
  data() {
    return {
      activeName: '1',
      newsList: [],
      productList: [],
      fileTaskList: [],
      is_new_data: {}
    }
  },
  created() {
    this.newFunctionGetList()
    this.stationLetterNewState()
  },
  methods: {
    handleClick() {
      if (+this.activeName === 3) {
        this.productTakeDownSendsList()
      } else if (+this.activeName === 4) {
        this.getFileTaskList()
      } else {
        this.newFunctionGetList()
      }
    },
    showNewFunction() {
      this.$emit('showNewFunction', this.activeName)
    },
    newFunctionGetList() {
      API.newFunctionGetList({ type: +this.activeName }).then(res => {
        this.newsList = res.data.map(item => ({
          ...item,
          en_date: new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(item.createDate) })
        )
      })
    },
    // 前台-用户获取产品下架接收列表
    productTakeDownSendsList() {
      API.productTakeDownSendsList().then(({ data }) => {
        this.productList = data.map(item => ({
          ...item,
          en_date: new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(item.createDate)
        }))
      })
    },
    // 心愿单导出列表查询
    getFileTaskList() {
      API.getFileTaskList().then(({ data }) => {
        this.fileTaskList = data.list.map(item => ({
          ...item,
          en_date: new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(item.createDate)
        }))
      })
    },
    stationLetterNewState() {
      API.stationLetterNewState().then(res => {
        this.is_new_data = res.data
        this.$store.commit('common/set', { newFunctionIsRead: (!!res.data['1'] || !!res.data['2'] || !!res.data['3']) || false })
      })
    },
    fileStatusColor(fileStatus) {
      if (fileStatus === 1 || fileStatus === 2) {
        return 'black'
      } else if (fileStatus === 4) {
        return 'red'
      } else {
        return '#99C41C' // Default color
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.informBox {
  /deep/ .head-tab .el-tabs__item{
    position: relative;
    font-size: 16px;
    span i{
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #F56C6C;
      display: inline-block;
      position: absolute;
      top: 7px;
      right: 12px;
    }
  }

  .content{
    position: relative;
    // max-height: 500px;
    height: 400px;
    padding: 0 10px;
    overflow: hidden;
    .message-item {
      padding: 16px 0 12px 0;
      border-bottom: .5px solid #eee;
      .title{
        font-size: 16px;
        color: #000;
        margin-bottom: 4px;
      }
      .text{
        color: #747A87;
        font-size: 14px;
      }
    }
    .product-item{
      padding: 14px 0;
      border-bottom: .5px solid #eee;
      .title{
        font-size: 16px;
        color: #000;
      }
      img{
        width: 80px;
        height: 106px;
        border-radius: 6px;
        flex-shrink: 0;
        margin-right: 22px;
      }
      .right{
        flex: 1;
        height: 100px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }
    }
    .empty{
      height: 400px;
      flex-direction: column;
      img{
        width: 200px;
        margin-bottom: 40px;
      }
    }
    .obscuration{
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100px;
      background: linear-gradient(to top, #FFFFFF, transparent);
    }
  }
  .more{
    padding: 10px;
    padding-bottom: 0;
    font-size: 18px;
    i{
      margin-left: 10px;
    }
  }
}
</style>
